import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useRfqSelectSearch } from '@/hooks/useRfqSelectSearch';
import type { RfqSummary } from '@/api/procurement.api';

export interface RfqSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onRfqChange?: (rfq: RfqSummary | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  name?: string;
}

/** Searchable RFQ picker — server search by RFQ number. */
export function RfqSelect({
  label = 'RFQ',
  value = '',
  onChange,
  onRfqChange,
  placeholder = 'Search RFQ…',
  disabled,
  className,
  required,
  error,
  name,
}: RfqSelectProps) {
  const { options, loading, searching, onSearchQuery, getRfq } = useRfqSelectSearch({ value });

  const handleChange = (next: string) => {
    onChange?.(next);
    onRfqChange?.(next ? getRfq(next) ?? null : null);
  };

  return (
    <SearchableSelect
      label={label}
      name={name}
      required={required}
      error={error}
      value={value}
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      loading={loading}
      searching={searching}
      className={className}
      searchPlaceholder="Search by RFQ number…"
      emptyMessage="No RFQs found"
      filterLocally={false}
      onSearchQuery={onSearchQuery}
    />
  );
}
